module.exports = eval("try{require('https')}catch(e){}");